import type React from "react";
import { createContext } from "react";
import { intitialFiltersState } from "../reducers/InitialStates/FiltersInitialState";
import type { Action, IFilters } from "../types/types";

export const FiltersContext = createContext<{
  filters: IFilters;
  dispatch: React.Dispatch<Action>;
}>({
  filters: intitialFiltersState,
  dispatch: () => null,
});
